import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

const HIDDEN_ON_ROUTES = new Set([
  "/selectezi-benefits",
  "/",
  "/investment-opportunities",
  "/marketing-agent",
  "/hire-marketing-agent",
  "/guideline",
  "/pricing",
  "/showcase"
]);

const MobileDownloadPopup = () => {
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [isInstallable, setIsInstallable] = useState(false);

  useEffect(() => {
    // Check if app is already running in standalone/installed mode
    const checkStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator &&
        "standalone" in window.navigator &&
        window.navigator.standalone);
    setIsStandalone(!!checkStandalone);

    // Detect if device is iOS (iPhone, iPad, iPod)
    const detectIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(detectIOS);

    // Listen for PWA installation prompt request
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setIsInstallable(true);

      const isMobile = window.innerWidth <= 768;
      if (isMobile && !checkStandalone) {
        setShow(true);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    // Initial and resize check for showing the mobile layout popup
    const checkMobileView = () => {
      const isMobile = window.innerWidth <= 768;
      if (isMobile && !checkStandalone) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    // Run mobile layout check
    checkMobileView();
    window.addEventListener("resize", checkMobileView);

    return () => {
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt,
      );
      window.removeEventListener("resize", checkMobileView);
    };
  }, []);

  useEffect(() => {
    if (show) {
      // Apply inline black backdrop styling for premium looks
      setTimeout(() => {
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.style.backgroundColor = "black";
          backdrop.style.opacity = "0.8";
        }
      }, 10);
    }
  }, [show]);

  // Handle native PWA installation
  const handleInstallClick = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();

    const { outcome } = await deferredPrompt.userChoice;
    // Reset and hide
    setDeferredPrompt(null);
    setIsInstallable(false);
    setShow(false);
  };

  // If already installed or running in standalone mode, do not show popup
  if (isStandalone) {
    return null;
  }

  if (HIDDEN_ON_ROUTES.has(pathname)) {
    return null;
  }

  // Render content based on platform install capabilities
  const renderModalContent = () => {
    return (
      <>
        {/* <Modal.Header closeButton>
          <Modal.Title>Welcome to <span style={{ fontWeight: "600", color: "#0353A4" }}>Selectezi</span></Modal.Title>
        </Modal.Header>
        <Modal.Body
          className="text-center"
          style={{ padding: "25px", fontSize: "14px" }}
        >
          <p>
            This is our official mobile app where you can explore all features
            and services.
          </p>
          <p style={{ fontWeight: "bold", marginTop: "10px" }}>
            Please click below to download the application for a better
            experience.
          </p>
        </Modal.Body>
        <Modal.Footer
          className="justify-content-center"
          style={{ borderTop: "none" }}
        >
          <Button
            style={{
              backgroundColor: "#000",
              border: "none",
              padding: "5px 25px",
              fontSize: "14px",
              borderRadius: "20px",
            }}
            href="https://your-download-link.com"
            target="_blank"
          >
            <CloudDownloadIcon fontSize="medium" className="mb-1" />{" "}
            &nbsp;Download App
          </Button>
        </Modal.Footer> */}
      </>
    );
  };

  return ( <>
  
  </>
    // <Modal
    //   show={show}
    //   onHide={() => setShow(false)}
    //   centered
    //   style={{ zIndex: 9999 }}
    //   backdrop="static"
    //   keyboard={false}
    // >
    //   {renderModalContent()}
    // </Modal>
  );
};

export default MobileDownloadPopup;
